@if (hasUpcomingOrLiveMeeting) {
    <div class="d-grid gap-3">
        @if (meeting) {
            <adapt-workflow-card-action [workflow]="workflow"
                                        [connection]="workflowConnection"
                                        [disabled]="!!nonStartableMeetingInfo"
                                        [disabledTooltip]="nonStartableMeetingInfo"
                                        [action]="isLiveMeeting ? joinMeeting : runMeeting"
                                        [actionText]="isLiveMeeting ? 'Join Meeting' : 'Run Meeting'"
                                        actionIcon="fal fa-fw fa-arrow-right">
                <adapt-display-meeting-summary [meeting]="meeting"
                                               [compact]="true"
                                               [showStartButton]="false"
                                               [showInfoIcon]="false"
                                               [linkDisabled]="true"></adapt-display-meeting-summary>
            </adapt-workflow-card-action>
        }
    </div>
}

@if (!meeting) {
    <div>
        <adapt-workflow-card-action [workflow]="workflow"
                                    [connection]="workflowConnection"
                                    actionText="Schedule meeting">
            <div>Meeting not scheduled</div>
        </adapt-workflow-card-action>
    </div>
}
